import apiRequest from './apiClient';

/**
 * Сохранить выбранный чат как предпочтение по умолчанию для публикации.
 * defaultChatId === null сбрасывает на личный чат с ботом.
 *
 * @param {number|null} defaultChatId
 * @param {string|null} userId  — для inline-режима
 * @param {string|null} hash    — для inline-режима
 */
export const updateMyTemplateDefaultChat = (defaultChatId, userId = null, hash = null) => {
  const params = userId && hash ? `?userId=${userId}&hash=${hash}` : '';
  return apiRequest(`/api/templates/me${params}`, {
    method: 'PATCH',
    body: JSON.stringify({ defaultChatId }),
  });
};
